import { DateInput } from "@/lib/Components/Form/Inputs/DateInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { TimePickerInput } from "@/lib/Components/Form/Inputs/TimePickerInput";

type AutoFocusField = "pickup_date" | "delivery_date" | "driver_notes";

export function WorkOrderAssignmentDetailsForm({
  autoFocusField,
}: {
  autoFocusField?: AutoFocusField;
}) {
  return (
    <>
      <DateInput
        name="pickup_date"
        label="Pickup Date"
        className="col-span-3"
        clearable
        autoFocus={autoFocusField === "pickup_date"}
      />
      <TimePickerInput
        name="pickup_time"
        label="Pickup Time"
        className="col-span-3"
      />
      <DateInput
        name="delivery_date"
        label="Delivery Date"
        className="col-span-3"
        clearable
      />
      <TimePickerInput
        name="delivery_time"
        label="Delivery Time"
        className="col-span-3"
      />
      <TextAreaInput
        name="driver_notes"
        label="Driver Notes"
        className="col-span-full"
        textAreaProps={{ rows: 3 }}
        autoFocus={autoFocusField === "driver_notes"}
      />
    </>
  );
}
